import { AfterContentInit, Component, OnInit } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { Client } from 'src/app/domain/client';
import { EUserType } from 'src/app/domain/enum/user-type';
import { User } from 'src/app/domain/user';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { ClientSelectionBoxDialog } from 'src/app/tools/ui/client-selection-box/client-selection-box';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConfirmBoxModel } from 'src/app/tools/ui/confirm-box/confirm-box.model';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { UserBoxComponent } from 'src/app/tools/ui/user-box/user-box.component';
import { MatListModule } from '@angular/material/list';
import { AvatarComponent } from '../../tools/ui/avatar/avatar.component';
import { NgStyle } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-user-configuration',
    templateUrl: './user-configuration.component.html',
    styleUrl: './user-configuration.component.scss',
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatButtonModule, PreventDoubleClickDirective, MatIconModule, NgStyle, AvatarComponent, MatListModule]
})
export class UserConfigurationComponent implements OnInit, AfterContentInit {
    EUserType = EUserType;
    private subject: Subject<string> = new Subject();
    SearchedString: string = '';
    AllUsers: User[] = [];
    UserList: User[] = [];
    SelectedUser?: User = undefined;
    ClientList: Client[] = [];

    constructor(
        private loadingTask: LoadingTask,
        public coreData: CoreData,
        private router: Router,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private userService: UserService
    ) { }

    ngOnInit(): void {
        this.GetAllUsers();
    }

    ngAfterContentInit(): void {

    }

    get CanSearch() {
        return StringTool.isNotNullOrEmpty(this.SearchedString);
    }

    getUserTypeLabel() {
        return StringConverter.getUserTypeName(this.SelectedUser?.Type as EUserType);
    }

    getUserIsActive() {
        return this.SelectedUser?.IsActive === true ? "Oui" : "Non";
    }

    onKeyUp() {
        this.searchClientList();
    }

    GetAllUsers() {
        this.userService.getAllUsers().subscribe(x => { this.AllUsers = x; this.UserList = x });
    }

    searchClientList() {

        this.UserList = this.AllUsers.filter(y =>
            y.Email.toLowerCase().includes(this.SearchedString.toLowerCase()) ||
            y.FirstName.toLowerCase().includes(this.SearchedString.toLowerCase()) ||
            y.LastName.toLowerCase().includes(this.SearchedString.toLowerCase()));

    }

    deleteClient(client: Client) {

        _.remove(this.SelectedUser?.ClientList!, x => x.Code === client.Code);
        this.userService.updateUser(this.SelectedUser as User).subscribe(x => {
            NotificationManager.handleSuccess(`Client retiré de ${this.SelectedUser?.Email}`, this.snackBar);
        });
    }

    assignSelectedUser(event: MatAutocompleteSelectedEvent) {
        this.SelectedUser = this.UserList.find(x => x.Email === event.option.value.Email) as User;
    }

    public compareWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
    }

    displayFn(user: User | string) {
        if (!user) {
            return '';
        }
        if (user instanceof User) {
            return user ? user.Email : '';
        }
        if (typeof (user) === "string") {
            return user;
        }
        return '';
    }

    openCreationBox(user?: User) {
        const dialogRef = this.dialog.open(UserBoxComponent, {
            data: user,
            width: '555px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: User) => {
            if (!result) {
                return;
            }
            if (user) {
                this.userService.updateUser(result).subscribe(x => {
                    this.SelectedUser = result;
                    NotificationManager.handleSuccess('Utilisateur modifié !', this.snackBar);
                });
                return;
            }
            this.userService.createUser(result).subscribe(x => {
                NotificationManager.handleSuccess('Utilisateur ajouté !', this.snackBar);
                this.SelectedUser = result;
                this.GetAllUsers();
            });
        });
    }

    openClientSelectionBoxForNewClient() {
        const dialogRef = this.dialog.open(ClientSelectionBoxDialog, {
            width: '1200px',
            data: {
                alreadyAssignedList: this.SelectedUser?.ClientList
            }
        });

        dialogRef.afterClosed().subscribe((result: Client[]) => {
            if (result) {
                // this.SelectedUser?.ClientList.push(...result);
                this.SelectedUser!.ClientList = result;
                this.updateUser(this.SelectedUser!)
            }
        });
    }

    updateUser(user: User) {
        this.userService.updateUser(user).subscribe(x => {
            this.SelectedUser = user;
            NotificationManager.handleSuccess('Utilisateur modifié !', this.snackBar);
        });
    }

    deleteUser() {
        if (!this.SelectedUser)
            return;

        const m: ConfirmBoxModel = new ConfirmBoxModel();
        m.QuestionTitle = 'Etes-vous sûr de vouloir supprimer cet utilisateur ?';
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: m,
            width: '777px',
            disableClose: true
        });
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.userService.deleteUser(this.SelectedUser!).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess(`L\'utilisateur ${this.SelectedUser?.FirstName} ${this.SelectedUser?.LastName} a été supprimé`, this.snackBar);
                        this.SelectedUser = undefined;
                    }
                })
            }
        });
    }

}
